import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, TooltipContent, TooltipTrigger } from '@pickleballinc/react-ui';
import { Dispatch, SetStateAction, TouchEvent } from 'react';

interface RankingTooltipProps {
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  handleTouch: (e: TouchEvent<HTMLDivElement>) => void;
  content: string;
}

export const RankingTooltip = ({
  open,
  onOpenChange,
  handleTouch,
  content,
}: RankingTooltipProps) => {
  return (
    <Tooltip open={open} onOpenChange={onOpenChange} placement='bottom'>
      <TooltipTrigger
        asChild
        onTouchStart={handleTouch}
        onMouseEnter={() => onOpenChange(true)}
        onMouseLeave={() => onOpenChange(false)}
      >
        <FontAwesomeIcon icon={faInfoCircle} className='text-gray-600 text-lg' />
      </TooltipTrigger>
      <TooltipContent className='w-52 rounded !bg-black p-2 text-center text-sm text-white z-50'>
        {content}
      </TooltipContent>
    </Tooltip>
  );
};
